export const statusOptions = [
  { value: 'Outstanding', label: 'Outstanding' },
  { value: 'Received', label: 'Received' },
  { value: 'Part Received', label: 'Part Received' }
];
